import { gql } from '@apollo/client';

export * from './depositorUpdate.mutation.generated';

export const DEPOSITOR_UPDATE = gql`
  mutation depositorUpdate($depositorId: ID!, $depositorParams: EscrowPartyParams!) {
    depositorUpdate(input: { depositorId: $depositorId, depositorParams: $depositorParams }) {
      success
      errors
      depositor {
        city
        companyName
        companyRegistrationNumber
        companyWebsite
        country
        id
        postalCode
        region
        street
        streetNumber
      }
    }
  }
`;
